<div class="d-grid gap-3" style="grid-template-columns: 350px 1fr" *ngIf="viewType !== 'table'">
  <app-automation-wizard-left
    [type]="type"
    (typeChange)="typeChange.emit($event)"
    image="/assets/images/automation-wizards/card.webp"
  >
    <ng-container i18n
      >The credit card entity handles payment methods for bookings, including adding, validating, and processing
      payments. Actions involve confirming card validity, updating booking statuses, and notifying guests or hosts about
      successful or failed payments. This entity ensures smooth financial transactions for bookings.</ng-container
    >
  </app-automation-wizard-left>
  <div class="card shadow">
    <div class="card-header flex-column align-items-start p-3 bg-default2">
      <h6 i18n>What would you like to do when a credit card is</h6>
      <div class="btn-group">
        <button
          type="button"
          (click)="onSelectEvent(events.PaymentCardAccepted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.PaymentCardAccepted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Accepted
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.PaymentCardDeleted)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.PaymentCardDeleted ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Deleted
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.PaymentCardDeclined)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.PaymentCardDeclined ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Declined
        </button>
        <button
          type="button"
          (click)="onSelectEvent(events.PaymentCardRejected)"
          class="btn btn-sm"
          [ngClass]="selectedEvent === events.PaymentCardRejected ? 'btn-info' : 'btn-outline-light'"
          i18n
        >
          Rejected
        </button>
      </div>
    </div>
    <div class="card-body d-flex flex-column gap-3">
      <ng-container [ngSwitch]="selectedEvent">
        <ng-template *ngSwitchCase="events.PaymentCardAccepted" [ngTemplateOutlet]="acceptedEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.PaymentCardDeleted" [ngTemplateOutlet]="deletedEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.PaymentCardDeclined" [ngTemplateOutlet]="declinedEvent"> </ng-template>
        <ng-template *ngSwitchCase="events.PaymentCardRejected" [ngTemplateOutlet]="rejectedEvent"> </ng-template>
      </ng-container>
      <div class="flex-fill"></div>
      <app-automation-channel-rental-select
        [form]="form"
        [allowsChannel]="false"
      ></app-automation-channel-rental-select>
    </div>
  </div>
</div>

<div *ngIf="viewType === 'table'" class="d-flex flex-column gap-4 automation-table">
  <div class="table-view-header text-muted text-semi-bold">
    <div class="text-uppercase text-muted mb-0" i18n>What would you like to do when</div>
    <div i18n>Created Date • Time</div>
    <div i18n>Last Triggered Date • Time</div>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Credit Card is Accepted</h6>
    <ng-template [ngTemplateOutlet]="acceptedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Credit Card is Deleted</h6>
    <ng-template [ngTemplateOutlet]="deletedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Credit Card is Declined</h6>
    <ng-template [ngTemplateOutlet]="declinedEvent"></ng-template>
  </div>
  <div class="container-box shadow">
    <h6 class="text-uppercase m-0 px-3 py-2" i18n>Credit Card is Rejected</h6>
    <ng-template [ngTemplateOutlet]="rejectedEvent"></ng-template>
  </div>
</div>

<ng-template #acceptedEvent>
  <app-do-action-automation
    [event]="events.PaymentCardAccepted"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingConfirmHandler"
    i18n-label
    i18n-name
    label="Confirm the booking"
    name="Confirm the booking when card accepted"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-guest-automation
    [event]="events.PaymentCardAccepted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the guest"
    name="Notify the guest of card accepted"
    [messageSubject]="guestNotificationMessages[events.PaymentCardAccepted].subject"
    [messageBody]="guestNotificationMessages[events.PaymentCardAccepted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-guest-automation>

  <app-notify-users-automation
    [event]="events.PaymentCardAccepted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of card accepted"
    [messageSubject]="userNotificationMessages[events.PaymentCardAccepted].subject"
    [messageBody]="userNotificationMessages[events.PaymentCardAccepted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #declinedEvent>
  <app-do-action-automation
    [event]="events.PaymentCardDeclined"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkFollowUp"
    i18n-label
    i18n-name
    label="Mark booking for follow-up"
    name="Mark booking for follow-up when card declined"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.PaymentCardDeclined"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkUnpaid"
    i18n-label
    i18n-name
    label="Mark booking as unpaid"
    name="Mark booking as unpaid when card declined"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-users-automation
    [event]="events.PaymentCardDeclined"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of card declined"
    [messageSubject]="userNotificationMessages[events.PaymentCardDeclined].subject"
    [messageBody]="userNotificationMessages[events.PaymentCardDeclined].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #rejectedEvent>
  <app-do-action-automation
    [event]="events.PaymentCardRejected"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkFollowUp"
    i18n-label
    i18n-name
    label="Mark booking for follow-up"
    name="Mark booking for follow-up when card rejected"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-do-action-automation
    [event]="events.PaymentCardRejected"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkUnpaid"
    i18n-label
    i18n-name
    label="Mark booking as unpaid"
    name="Mark booking as unpaid when card rejected"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-users-automation
    [event]="events.PaymentCardRejected"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of card rejected"
    [messageSubject]="userNotificationMessages[events.PaymentCardRejected].subject"
    [messageBody]="userNotificationMessages[events.PaymentCardRejected].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>

<ng-template #deletedEvent>
  <app-do-action-automation
    [event]="events.PaymentCardDeleted"
    [type]="automationTypes.Booking"
    [viewType]="viewType"
    [eventSourceType]="type"
    [handler]="eventHandlers.BookingMarkFollowUp"
    i18n-label
    i18n-name
    label="Mark booking for follow-up"
    name="Mark booking for follow-up when card deleted"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-do-action-automation>

  <app-notify-users-automation
    [event]="events.PaymentCardDeleted"
    [viewType]="viewType"
    [eventSourceType]="type"
    i18n-label
    i18n-name
    label="Notify the user(s)"
    name="Notify the user(s) of card deleted"
    [messageSubject]="userNotificationMessages[events.PaymentCardDeleted].subject"
    [messageBody]="userNotificationMessages[events.PaymentCardDeleted].message"
    [rentals]="form.get('rentals').value"
    [channels]="form.get('channels').value"
  ></app-notify-users-automation>
</ng-template>
